import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import BlockTypes from '../../../types/BlockTypes';
export default {
  html: _defineProperty({}, BlockTypes.EMBED, function (_ref) {
    var node = _ref.node,
        attributes = _ref.attributes;
    var url = node.getIn(['data', 'url']);
    return React.createElement("p", null, React.createElement("a", Object.assign({}, attributes, {
      href: url
    }), url));
  }),
  markdown: _defineProperty({}, BlockTypes.EMBED, function (_ref2) {
    var node = _ref2.node;
    var url = node.getIn(['data', 'url']).replace(' ', '+');
    return "[[".concat(url, "]](").concat(url, ")\n\n");
  })
};